import { useQuery } from '@tanstack/react-query';

// Shared base for the promotion-payout list queries (promotion batches and
// per-professional history): same options and { payouts, isLoading } shape.
export const usePromotionPayoutsQuery = (queryKey, queryFn, options) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey,
    queryFn,
    enabled: options?.enabled ?? true,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    payouts: data || [],
    error,
    isError,
    isLoading: isLoading || isFetching,
  };
};
